import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_CHEMISTUSERDETAILS_INIT_ACTION,
  FETCH_CHEMISTUSERDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTUSERDETAILS_FAIL_ACTION,
  FETCH_CHEMISTINACTIVE_INIT_ACTION,
  FETCH_CHEMISTINACTIVE_SUCCESS_ACTION,
  FETCH_CHEMISTINACTIVE_FAIL_ACTION,
  FETCH_CHEMISTOPERATION_INIT_ACTION,
  FETCH_CHEMISTOPERATION_SUCCESS_ACTION,
  FETCH_CHEMISTOPERATION_FAIL_ACTION,
  FETCH_CHEMISTDETAILSVIEW_INIT_ACTION,
  FETCH_CHEMISTDETAILSVIEW_SUCCESS_ACTION,
  FETCH_CHEMISTDETAILSVIEW_FAIL_ACTION,
  FETCH_OFFERS_INIT,
  FETCH_OFFERS_SUCCESS,
  FETCH_OFFERS_FAIL,
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchChemistUser(value) {
  const token = localStorage.getItem("token");
  console.log(value);

  let pageno = !value.value
    ? 1
    : value.value.pageno === undefined
    ? 1
    : value.value.pageno;
  let filter = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;
  let search = !value.value
    ? ""
    : value.value.search === ""
    ? ""
    : value.value.search;

  try {
    const res = yield fetch(
      `${appConfig.ip}/users?role=chemist&limit=10&page=${pageno}&search=${search}&status=${filter}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log(res);
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTUSERDETAILS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTUSERDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchchemistdetailsview(value) {
  let id = value.value;
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/orgProf/` + id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTDETAILSVIEW_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTDETAILSVIEW_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchchemistOfferDtls(value) {
  let id = value.value;
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/offer?userId=${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_OFFERS_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_OFFERS_FAIL, error: err });
    } else {
    }
  }
}

function* fetchChemistInActive(data) {
  let datas =
    data.value.item.status === "active"
      ? { status: "suspended" }
      : { status: "active" };

  const id = data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/users/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      console.log("-------------",resJSON)
      yield put({
        type: FETCH_CHEMISTINACTIVE_SUCCESS_ACTION,
        payload: resJSON,
      });

      const refreshParams =
        data &&
        data.value &&
        data.value.refreshParams
          ? data.value.refreshParams
          : undefined;
      yield put({
        type: FETCH_CHEMISTUSERDETAILS_INIT_ACTION,
        value: refreshParams,
      });
      if (data.value.item.ftLogin === false) {
        const res2 = yield fetch(`${appConfig.ip}/orgProf/` + id, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(datas),
        });
        if (!res2.ok) {
          throw res2;
        } else {
          const resJSON2 = yield res2.json();
          console.log("----------resJSON2---",resJSON2)
        }
      }
      yield toast.success("Status changed successfully", {
        autoClose: 3000,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTINACTIVE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchChemistOperation(data) {
  let datas =
    data.value.item.oprMode === "open"
      ? { oprMode: "closed" }
      : { oprMode: "open" };

  const id = data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/users/changeOprMode/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield toast.success("Mode of operation changed successfully", {
        autoClose: 3000,
      });
      yield put({
        type: FETCH_CHEMISTOPERATION_SUCCESS_ACTION,
        payload: resJSON,
      });
      const refreshParams =
        data &&
        data.value &&
        data.value.refreshParams
          ? data.value.refreshParams
          : undefined;

      yield put({
        type: FETCH_CHEMISTUSERDETAILS_INIT_ACTION,
        value: refreshParams,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTOPERATION_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* ChemistActionWatcher() {
  yield takeEvery(FETCH_CHEMISTUSERDETAILS_INIT_ACTION, fetchChemistUser);
  yield takeEvery(FETCH_CHEMISTINACTIVE_INIT_ACTION, fetchChemistInActive);
  yield takeEvery(
    FETCH_CHEMISTDETAILSVIEW_INIT_ACTION,
    fetchchemistdetailsview
  );
  yield takeEvery(FETCH_CHEMISTOPERATION_INIT_ACTION, fetchChemistOperation);
  yield takeEvery(FETCH_OFFERS_INIT, fetchchemistOfferDtls);
}
